"use client";

import { useState } from "react";
import { TiersPricingTable, type PaymentFrequency } from "@/app/components/TiersPricingTable";
import { useRouter } from "next/navigation";
import type { UserTier } from "@/lib/config/tiers/types";

export default function PricingPage() {
  const router = useRouter();
  const [paymentFrequency, setPaymentFrequency] = useState<PaymentFrequency>("annual");

  const handleTierButtonClicked = (tierId: UserTier) => {
    // For now, navigate to a contact or signup page
    // In the future, this could integrate with Stripe or payment processing
    router.push(`/contact?tier=${tierId}`);
  };

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Choose Your Plan
        </h1>
        <p className="text-lg text-base-content/70 max-w-2xl mx-auto">
          Select the perfect tier for your community. Upgrade or downgrade anytime.
        </p>
      </div>

      <div className="flex justify-center mb-2">
        <div className="tabs tabs-box">
          <input
            type="radio"
            name="payment-frequency"
            className="tab"
            aria-label="Monthly"
            checked={paymentFrequency === "monthly"}
            onChange={() => setPaymentFrequency("monthly")}
          />
          <input
            type="radio"
            name="payment-frequency"
            className="tab"
            aria-label="Annually"
            checked={paymentFrequency === "annual"}
            onChange={() => setPaymentFrequency("annual")}
          />
        </div>
      </div>

      <p className="text-xs text-center mb-8 min-h-[1.5em]">
        {paymentFrequency === "annual" ? (
          <span className="font-bold text-accent">Includes 10% discount</span>
        ) : (
          <button
            type="button"
            onClick={() => setPaymentFrequency("annual")}
            className="text-accent link"
          >
            Save 10% with annual payment
          </button>
        )}
      </p>

      <TiersPricingTable
        showButtons={true}
        buttonTitle="Get Started"
        currentTierButtonTitle="Current Plan"
        paymentFrequency={paymentFrequency}
        onTierButtonClicked={handleTierButtonClicked}
      />

      <div className="text-center mt-12 text-sm text-base-content/70">
        <p>All plans include access to core features and regular updates.</p>
        <p className="mt-2">
          Need a custom solution? <a href="/contact" className="link link-primary">Contact us</a>
        </p>
      </div>
    </div>
  );
}
